import React from 'react'
//import Constant from './Constant'
//import SimplexNoise from 'simplex-noise'
//import './background/shift.js'
//import './background/aurora.js'

//const {backgrounds} = Constant
/*const map = {}
if (Array.isArray(backgrounds)&&backgrounds.length>0) {
  backgrounds.forEach((e,i)=>{
    map[e] = require(`./background/${e}.js`)
  })
}*/

export default class Background extends React.Component {
  state={}
  componentDidMount() {
  }
  render() {
    const {value} = this.props
    if (typeof(value)==='string'&&value.length>0) {
      //require(`./background/${value}.js`)
      //eval(map[value])
      require(`./background/${value}.js`)
      return (
        <div className="content--canvas"></div>
      )
    }
    return null
  }
}
